import * as React from 'react'
import * as ReactDom from 'react-dom'
import { Link } from 'react-router-dom';
import { ResourceProvider } from '../../resourceProvider';
import ReactTooltip from 'react-tooltip'

export interface ISkodaTooltipProps {
	id: string,
	customAnchorClass?: string,
	customTooltipClass?: string,
	customTooltipContent?: (parentKey: string) => JSX.Element,
	message?: string,
	type?: ReactTooltip.Type,
	effect?: ReactTooltip.Effect
	position?: ReactTooltip.Place
}

export interface ISkodaTooltipState {
	isMobilePluginVisible: boolean
}

export class SkodaTooltip extends React.Component<ISkodaTooltipProps, ISkodaTooltipState>
{
	constructor(props: ISkodaTooltipProps) {
		super(props);

		this.onClickCloseTooltip = this.onClickCloseTooltip.bind(this);
		this.onClickOpenTooltip = this.onClickOpenTooltip.bind(this);

		this.state = {
			isMobilePluginVisible: false
		};
	}

	private onClickOpenTooltip(e: any): void {
		e.stopPropagation();
		if (!this.state.isMobilePluginVisible) {
			document.getElementById(this.props.id).classList.remove('show');
			this.setState({
				isMobilePluginVisible: true
			});
		}
	}

	private onClickCloseTooltip(e: any): void {
		e.stopPropagation();

		this.setState({
			isMobilePluginVisible: false
		});
	}

	public render(): JSX.Element {

		return (
			<div className={'skoda-tooltip ' + (this.props.customAnchorClass ? this.props.customAnchorClass : '')} data-tip data-for={this.props.id} onClick={this.onClickOpenTooltip}>

				{
					this.props.children
				}

				<ReactTooltip id={this.props.id} type={this.props.type ? this.props.type : 'light'} effect={this.props.effect ? this.props.effect : 'solid'} place={this.props.position ? this.props.position : 'top'} multiline={true} className="tooltip-plugin">
					{
						(this.props.customTooltipContent != null && this.props.customTooltipContent != undefined) && this.props.customTooltipContent('desktopTooltip')
					}
					{
						this.props.message &&
						<span key={'tooltip_message'}>
							{this.props.message}
						</span>
					}
				</ReactTooltip>

				<div className={'tooltip-plugin-mobile-overlay' + (this.state.isMobilePluginVisible ? ' show' : '')} id={this.props.id + '-mobile'}>
					<div className={'tooltip-plugin-mobile type-dark' + (this.state.isMobilePluginVisible ? ' show' : '')}>
						{
							(this.props.customTooltipContent != null && this.props.customTooltipContent != undefined) && this.props.customTooltipContent('mobileTooltip')
						}
						{
							this.props.message &&
							<div className="tooltip-message-container">
								<span key={'tooltip_message_mobile'}>
									{this.props.message}
								</span>
							</div>
						}
						<div className="btn-tooltip-close-container">
							<button className="btn button-border-radius btn-tooltip-close" onClick={this.onClickCloseTooltip}>
								{ResourceProvider.getText('Tooltip.Close')}
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}